module.exports = __webpack_public_path__ + "static/the-48-laws-of-power-4987c204c77daacde412cea52eaf566e.jpg";